import { useEffect } from 'react'
import { createContext, useContext } from 'react'
import { tenant } from '@/tenants/tenant'
import type { TenantOverrides } from '@/tenants/tenant-config'

const TenantOverridesContext = createContext<TenantOverrides>({})

export function ThemeProvider({ children }: { children: React.ReactNode }) {
	const overrides = tenant.overrides

	useEffect(() => {
		const root = document.documentElement
		const { colors, fonts } = tenant

		root.style.setProperty('--background', colors.background)
		root.style.setProperty('--foreground', colors.foreground)
		root.style.setProperty('--card', colors.card)
		root.style.setProperty('--card-foreground', colors.cardForeground)
		root.style.setProperty('--popover', colors.popover)
		root.style.setProperty('--popover-foreground', colors.popoverForeground)
		root.style.setProperty('--primary', colors.primary)
		root.style.setProperty('--primary-foreground', colors.primaryForeground)
		root.style.setProperty('--secondary', colors.secondary)
		root.style.setProperty('--secondary-foreground', colors.secondaryForeground)
		root.style.setProperty('--muted', colors.muted)
		root.style.setProperty('--muted-foreground', colors.mutedForeground)
		root.style.setProperty('--accent', colors.accent)
		root.style.setProperty('--accent-foreground', colors.accentForeground)
		root.style.setProperty('--destructive', colors.destructive)
		root.style.setProperty('--destructive-foreground', colors.destructiveForeground)
		root.style.setProperty('--border', colors.border)
		root.style.setProperty('--input', colors.input)
		root.style.setProperty('--ring', colors.ring)
		root.style.setProperty('--font-sans', fonts.sans)
	}, [])

	return <TenantOverridesContext.Provider value={overrides}>{children}</TenantOverridesContext.Provider>
}

export function useOverrides<K extends keyof TenantOverrides>(name: K): NonNullable<TenantOverrides[K]> {
	const overrides = useContext(TenantOverridesContext)
	return (overrides[name] ?? {}) as NonNullable<TenantOverrides[K]>
}
